import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIndustriekunde = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 103,
	height: 102.992,
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 50,
			y: 140,
			width: 10,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 70,
			y: 140,
			width: 10,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 90,
			y: 140,
			width: 10,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 110,
			y: 140,
			width: 10,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 130,
			y: 140,
			width: 10,
			height: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#00488E",
			className: "cls-1",
			x: 150,
			y: 140,
			width: 10,
			height: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00488E",
			className: "cls-1",
			d: "M70,30c8.06,0,12.66,2.21,18.47,5.01,7.29,3.51,15.55,7.49,31.53,7.49v-10c-13.7,0-20.56-3.3-27.19-6.5-6.13-2.95-12.46-6-22.81-6-22.15,0-33.43,13.79-33.9,14.38l7.79,6.27c.36-.43,8.95-10.65,26.12-10.65Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00488E",
			className: "cls-1",
			d: "M174.02,77.6c-18.66,3.73-41.87,20.07-54.02,29.45v-30.65l-5.98,1.2c-18.66,3.73-41.87,20.07-54.02,29.45V47.5H20V180H180V76.4l-5.98,1.2ZM30,57.5h20v12.5H30v-12.5Zm140,112.5H30V80h20v40h9.81c6.27-5.16,30.41-24.36,50.19-30.97v30.97h9.81c6.27-5.16,30.41-24.36,50.19-30.97v80.97Z"
		})
	]
});
export default SvgIndustriekunde;
